const untilActions = {
  SET_FORCE_RELOAD: 'SET_FORCE_RELOAD',
  SCROLL_TO_TOP: 'SCROLL_TO_TOP',
  SET_NAV_BAR: 'SET_NAV_BAR',


  forceReload: payload => ({
    type: untilActions.SET_FORCE_RELOAD,
    payload,
  }),
  setNavBar: payload => ({
    type: untilActions.SET_NAV_BAR,
    payload,
  }),
  scrollToTop: payload => ({
    type: untilActions.SCROLL_TO_TOP,
    payload,
  }),
};

export default untilActions;
